import { Box } from '@chakra-ui/react';
import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

import { z } from 'zod/v4';
import { useCreditFacilityOrThrow } from '~/contexts/CreditFacilitiesProvider';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { PortfolioCreditAgreementContainer } from '~/packages/portfolio/ui/creditAgreement/PortfolioCreditAgreement';
import { PortfolioTemplate } from '~/packages/portfolio/ui/shared/PortfolioTemplate';

// Types
const RouteParamsStruct = z.object({
  creditFacility: z.string({ message: 'Missing URL parameter' }),
});

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();
  const [queryParams] = useSearchParams();
  const { creditFacility: creditFacilityId } = RouteParamsStruct.parse(
    Object.fromEntries(queryParams),
  );
  const creditFacility = useCreditFacilityOrThrow(creditFacilityId);

  return (
    <PortfolioTemplate
      creditFacilityId={creditFacility.id}
      creditFacilityName={creditFacility.name}
      selectedTab="creditAgreement"
    >
      <PortfolioCreditAgreementContainer
        creditFacilityId={creditFacility.id}
        orgSlug={user.organization.slug}
        organizationId={user.organization.id}
      />
    </PortfolioTemplate>
  );
};

// Exports
export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/portfolio/overview/facilities" />;
      }}
    >
      <Box width="100%" padding="2.5rem">
        <RouteBase />
      </Box>
    </RouteErrorBoundary>
  );
};
